import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { formatDateArray } from "../../utils/date/format"
import { Search, CalendarDays } from "lucide-react"

const BottomHead = ({ from, to, isDeparture, roundTrip }) => {
  const { t, i18n } = useTranslation()
  const locale = i18n.language

  const displayDate = useMemo(() => {
    const fromArray = Array.isArray(from) ? from : []
    const toArray = Array.isArray(to) ? to : []
    return isDeparture ? formatDateArray(fromArray, locale) : formatDateArray(toArray, locale)
  }, [isDeparture, locale, from, to])
  return (
    <div className="px-6 py-4 bg-gray-50">
      <div className="flex gap-4 max-w-[340px]">
        {isDeparture ? (
          <div className="flex-1">
            <Label>{t("admin.departure_v2")}</Label>
            <Input placeholder={t("admin.select_departure_date")} value={displayDate} />
          </div>
        ) : (
          <div className="flex-1 relative">
            <div className="flex items-center justify-between">
              <Label>{t("admin.return_v2")}</Label>
              {!roundTrip && (
                <button className="text-sm absolute right-0 -top-1 text-app-state rounded-md bg-app-state/15 p-0.5 font-medium hover:text-app-state/70">
                  - {t("admin.one_way_ticket_v3")} -
                </button>
              )}
            </div>
            <Input placeholder={t("admin.select_return_date")} value={displayDate} />
          </div>
        )}
      </div>
    </div>
  )
}

export default BottomHead

const Label = ({ children }) => (
  <label className="text-sm text-app-content-faint font-medium block">{children}</label>
)

const Input = ({ value = "", placeholder, onChange }) => (
  <div className="flex items-center gap-2 px-2 py-1 bg-gray-100 rounded border border-gray-300 hover:border-gray-400 focus-within:border-blue-500 transition-colors text-xs">
    <CalendarDays
      size={14}
      className={!value ? "text-app-content-faint/50" : "text-app-base-strong"}
    />
    <input
      type="text"
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      readOnly
      disabled
      className="flex-1 bg-transparent text-xs text-app-content outline-none placeholder:text-app-content-faint placeholder:text-opacity-50"
    />
    <Search size={14} className="text-app-content-faint/50" />
  </div>
)
